import { render, staticRenderFns } from "./erkai.vue?vue&type=template&id=bf72d0bc&scoped=true&"
import script from "./erkai.vue?vue&type=script&lang=js&"
export * from "./erkai.vue?vue&type=script&lang=js&"
import style0 from "./erkai.vue?vue&type=style&index=0&id=bf72d0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf72d0bc",
  null
  
)

export default component.exports